import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useTourSuggestions(query, { minLength = 2, debounceMs = 250 } = {}) {
  const [suggestions, setSuggestions] = useState([]);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    const q = (query || "").trim();
    if (q.length < minLength) {
      setSuggestions([]);
      return;
    }
    timerRef.current = setTimeout(async () => {
      try {
        const { data } = await api.get("/tours/suggest", { params: { q } });
        setSuggestions(data);
      } catch (e) {
        console.warn("[useTourSuggestions] failed:", e?.message || e);
      }
    }, debounceMs);
    return () => clearTimeout(timerRef.current);
  }, [query, minLength, debounceMs]);

  return suggestions;
}
